module.exports = __webpack_public_path__ + "static/media/deep_refresh_sky_disabled.be1184db.png";